import React from "react";
import {useTranslation} from "react-i18next";

export default function EmptyPlaceholder({type, mod, width, message}) {
    const {t} = useTranslation();
    return (
        <div style={{
            marginTop: '8rem'
        }}>
            <img alt={'placeholder'} src={`/empty_placeholder${mod ? `_${mod}` : ''}.png`} width={width ? width : '270px'} style={{pointerEvents: 'none'}}/>
            <div
                className={'mt-3'}
                style={{
                    color: "#334155",
                    fontWeight: '500',
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    textAlign: 'center',
                    userSelect: "none"
                }}
            >{message ? message : t('empty.default', {type})}</div>
        </div>
    );
}